module.exports = __webpack_public_path__ + "img/data-point-details.3bdba053.png";